import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const EmailIcon = (props: IconProps) => (
  <Icon w="54px" h="54px" viewBox="0 0 54 54" {...props}>
    <path d="M51.75 16.594c0-1.702-1.38-3.094-3.068-3.094H24.136c-1.687 0-3.068 1.392-3.068 3.094L18 35.156c0 1.702 1.38 3.094 3.068 3.094h24.546c1.687 0 3.068-1.392 3.068-3.094l3.068-18.562Zm-3.068 0-12.273 7.734-12.273-7.734h24.546Zm-3.068 18.562H21.068l3.068-15.468 12.273 7.734 12.273-7.735-3.068 15.47Z" />
    <rect width="15.75" height="2.25" x="2.25" y="15.75" rx="1.125" />
    <rect width="9" height="2.25" x="6.75" y="22.5" rx="1.125" />
    <rect width="4.5" height="2.25" x="9" y="29.25" rx="1.125" />
  </Icon>
);

export default memo(EmailIcon);
